import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useAlerta, useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Funcao from 'Interface/Funcoes';
import { Erro } from 'Interface/Requisicao';
import { recuperarMensagemDeErro } from 'View/functions';
import {
  useEditarFuncaoMutation,
  useRecuperarFuncaoQuery,
} from 'View/Service/Default/Funcoes';

const regras = object({
  nome: string().required('Obrigatório'),
});

const Editar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const alerta = useAlerta();
  const { id = 0 } = useParams();
  const [editarFuncao] = useEditarFuncaoMutation();

  const { data: { funcao } = {}, isLoading } = useRecuperarFuncaoQuery(id);

  const enviar = async (dados: Funcao): Promise<void> => {
    try {
      await editarFuncao(dados).unwrap();

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

      navegacao('/funcoes');
    } catch (error) {
      alerta({
        titulo: 'Erro ao adicionar',
        conteudo: recuperarMensagemDeErro((error as Erro).data.errors),
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Editando função"
        descricao="Altere o formulário e clique em enviar para editar a função"
      />
      <Form
        onSubmit={enviar}
        inicial={funcao}
        desabilitado={isLoading}
        regras={regras}
      >
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="nome" rotulo="Nome" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/funcoes" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Editar;
